import { NotFound } from '@jcm/design-system';
import estilo from './index.module.scss';

export default function PaginaNaoEncontrada() {
	return <NotFound className={estilo.componenteNaoEncontrado} />;
}
